import { defineFieldAdapter, type FieldTransformers } from '@libs/shared/frontend/helpers/define-field-adapter.helper';

import { OrganizationUserRoleEnum, type components } from '@/libs/openapi';
import { formatDate, formatEnumValue } from '@/utils/format.util';

export const fromApiUserFieldAdapter = defineFieldAdapter({
  fields: {
    role: formatEnumValue(OrganizationUserRoleEnum),
    createdAt: formatDate('withTime'),
  } satisfies FieldTransformers<components['schemas']['MeResponseDto']>,
  meta: {
    getInitials: (row: Pick<components['schemas']['UserResponseDto'], 'firstName' | 'lastName'>) => `${row.firstName?.charAt(0)?.toUpperCase() ?? ''}${row.lastName?.charAt(0)?.toUpperCase() ?? ''}`.trim(),
    getFullName: (row: Pick<components['schemas']['UserResponseDto'], 'firstName' | 'lastName'>) => `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim(),
    getCoveredUntil: formatDate('full'),
  },
}, 'strict');
